<template>
  <button
    v-if="visible"
    type="button"
    :class="[
      'flex items-center text-gray-500 hover:text-gray-700',
      position === 'inline' ? 'mt-2' : 'absolute',
      positionClass,
    ]"
    @click="emit('hide')"
  >
    <vue-feather type="eye" size="16" />
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type Props = {
  visible: boolean;
  position?: 'top-right' | 'center-right' | 'center-right-offset' | 'inline';
};

const props = withDefaults(defineProps<Props>(), {
  position: 'center-right',
});

const emit = defineEmits<{
  hide: [];
}>();

const positionClass = computed(
  () =>
    ({
      'top-right': 'right-2 top-2',
      'center-right': 'right-2 top-0 bottom-0',
      'center-right-offset': 'right-10 top-0 bottom-0',
      inline: '',
    })[props.position]
);
</script>
